import type { CSSProperties } from 'react'

/** Solid = saturated fill. Tinted = pale fill. */
export type AvatarMode = 'solid' | 'tinted'

export const AVATAR_MODES: AvatarMode[] = ['solid', 'tinted']

export type AvatarColor =
  | 'gray'
  | 'red'
  | 'orange'
  | 'yellow'
  | 'lime-green'
  | 'vivid-green'
  | 'pale-green'
  | 'teal'
  | 'cyan'
  | 'blue'
  | 'indigo'
  | 'purple'
  | 'pink'
  | 'avatar'

export type AvatarProps = {
  mode?: AvatarMode
  /**
   * When true, renders the tinted (pale) appearance
   * regardless of `mode`. Prefer this when the avatar sits on a dark surface.
   */
  darkMode?: boolean
  color?: AvatarColor
  initials?: string
  name?: string
  src?: string
  alt?: string
  size?: number
  className?: string
  style?: CSSProperties
}

export const AVATAR_COLORS: AvatarColor[] = [
  'gray',
  'red',
  'orange',
  'yellow',
  'lime-green',
  'vivid-green',
  'pale-green',
  'teal',
  'cyan',
  'blue',
  'indigo',
  'purple',
  'pink',
  'avatar',
]

export const getInitialsFromName = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
